import { signal, WritableSignal } from "@angular/core";
import { IMenu } from "@app/core";

export class CatalogSubMenuModel implements IMenu {
    public subMenu?: WritableSignal<IMenu> = signal<IMenu>(null);
}  